export default "__VITE_ASSET__BYih1p3l__"